<template>
    <div>
        <calculation-construction-material-list/>
        <calculation-control ref="control"/>
        <calculation-documents @rmkLayout="pushEvent($event)"/>
    </div>
</template>

<script>
import CalculationConstructionMaterialList from './material/ConstructionMaterialList';
import CalculationDocuments from './document/Documents';
import CalculationControl from './control/CalculationControl';

export default {
    name:       'CalculationConstruction',
    components: {
        CalculationControl,
        CalculationDocuments,
        CalculationConstructionMaterialList,
    },
    methods:    {
        pushEvent(index) {
            this.$refs.control.pushRmkLayout(index);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/calculation/calculator/construction/Construction.vue